import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CommonProfilePasswordChangeService,
  ChangePasswordRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class CommonProfilePasswordChangeApiService {
  constructor(private apiService: CommonProfilePasswordChangeService) {}

  public changePassword(body: ChangePasswordRequest, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.changePassword(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public checkPasswordChangeRequest(value: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.changePasswordCheck({ value }, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public changePasswordRequest(requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.changePasswordRequest(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
